'use client';

import type { JSX } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { ReorderSlice } from '@/components';

export type ReorderProps = SliceComponentProps<Content.ReorderSlice>;

/** Forwards the whole slice so a future variation is a branch inside `ReorderSlice`, not new props here. */
const Reorder = ({ slice }: ReorderProps): JSX.Element | null => (
  <ReorderSlice {...slice} />
);

export default Reorder;
